import { BaseApi, configuration } from '../../../api/BaseApi'
import { AccountBean, AccountControllerApi, ItemResponseAccountBeanObject, ListResponseAccountBean } from '../../../api/api'
import { StorageKey } from '../../../util/Storage'

class AccountApi extends BaseApi {
    api: AccountControllerApi

    constructor() {
        super()
        this.api = new AccountControllerApi(configuration, configuration.basePath, this.fetch)
    }

    list(size: number = 20, page: number = 1, sort, search): Promise<ListResponseAccountBean> {
        return this.call(() => this.api.accounts(search, { query: { size, page, sort } }))
    }

    all(): Promise<ListResponseAccountBean> {
        return this.call(() => this.api.accounts())
    }

    create(account: AccountBean): Promise<ItemResponseAccountBeanObject> {
        return this.call(() => this.api.createAccount(account))
    }

    edit(id: any, account: AccountBean): Promise<ItemResponseAccountBeanObject> {
        return this.call(() => this.api.editAccount(account, id))
    }

    view(id: any): Promise<ItemResponseAccountBeanObject> {
        return this.call(() => this.api.account(id))
    }

    viewUser(): Promise<ItemResponseAccountBeanObject> {
        return this.call(() => this.api.accountProps())
    }

    delete(id: any): Promise<any> {
        return this.call(() => this.api.deleteAccount(id))
    }

    async login(username: string, password: string): Promise<boolean> {
        const form = 'username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password)
        const options: RequestInit = {
            method: 'POST',
            body: form,
            headers: {
                'secure-cookie': 'true',
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        try {
            await this.fetch(configuration.basePath + '/api/login', options)
            localStorage.setItem(StorageKey.Authenticated, 'true')
            return Promise.resolve(true)
        } catch (e) {
            localStorage.setItem(StorageKey.ApiError, 'Incorrect Username or Password')
            return Promise.resolve(false)
        }
    }

    async logout(): Promise<boolean> {
        const options: RequestInit = { method: 'GET' }
        try {
            await this.fetch(configuration.basePath + '/api/logout', options)
            localStorage.removeItem(StorageKey.Authenticated)
            localStorage.removeItem(StorageKey.TokenExpiration)
            return Promise.resolve(true)
        } catch (e) {
            return Promise.resolve(false)
        }
    }
}

const accountApi = new AccountApi()
export default accountApi


// WEBPACK FOOTER //
// ./src/component/app/account/AccountApi.ts